// Utilities to compute skills and filter companies from experience data

export const extractOperatingSystems = (experience) => {
  const osKeywords = ['Windows', 'Linux', 'AOSP', 'Android', 'macOS', 'iOS', 'Unix'];
  const foundOS = new Set();
  (experience || []).forEach(exp => {
    (exp.technologies || []).forEach(tech => {
      osKeywords.forEach(os => {
        const osLower = os.toLowerCase();
        const techLower = String(tech).toLowerCase();
        if (techLower === osLower || techLower.includes(osLower)) {
          // Ensure exact word match or full match
          const regex = new RegExp(`\\b${osLower}\\b`, 'i');
          if (regex.test(String(tech))) {
            foundOS.add(os);
          }
        }
      });
    });
  });
  return Array.from(foundOS).sort();
};

export const extractProgrammingLanguages = (experience) => {
  const languages = ['C', 'C++', 'C#', 'JavaScript', 'Java', 'Kotlin', 'Python', 'PHP', 'PowerShell', 'Bash', 'MEL', 'TypeScript', 'Go', 'Rust', 'Swift', 'Objective-C', 'Ruby', 'Perl', 'Scala', 'Haskell', 'Clojure', 'F#'];
  const found = new Set();
  (experience || []).forEach(exp => {
    (exp.technologies || []).forEach(tech => {
      languages.forEach(lang => {
        if ((lang === 'C#' && tech === 'C#') ||
            (lang === 'C++' && tech === 'C++') ||
            (lang === 'C' && tech === 'C' && tech !== 'C++' && tech !== 'C#') ||
            (lang !== 'C' && lang !== 'C++' && lang !== 'C#' && String(tech).toLowerCase() === lang.toLowerCase())) {
          found.add(lang);
        }
      });
    });
  });
  return Array.from(found).sort();
};

export const extractTechStacks = (experience) => {
  const found = new Set();
  (experience || []).forEach(exp => {
    (exp.technologies || []).forEach(tech => {
      const t = String(tech).toLowerCase();
      if (t.includes('unity') ||
          t.includes('angular') ||
          t.includes('aosp') ||
          t.includes('react') ||
          t.includes('node') ||
          t.includes('android') ||
          t.includes('embedded') ||
          t.includes('firmware') ||
          t.includes('sdk') ||
          t.includes('plugins') ||
          t.includes('rest') ||
          t.includes('cloud') ||
          t.includes('computer vision') ||
          t.includes('maya') ||
          t.includes('mel') ||
          t.includes('adobe') ||
          t.includes('renderman') ||
          t.includes('shaders') ||
          t.includes('opengl') ||
          t.includes('directx') ||
          t.includes('glide') ||
          t.includes('smtp') ||
          t.includes('pop3') ||
          t.includes('exchange') ||
          t.includes('sendmail') ||
          t.includes('ace') ||
          t.includes('firewall1') ||
          t.includes('ldap') ||
          t.includes('vr') ||
          t.includes('ar') ||
          t.includes('xr') ||
          t.includes('cybersecurity') ||
          t.includes('win-internals')) {
        found.add(tech);
      }
    });
  });
  return Array.from(found).sort();
};

export const buildSkills = (experience) => ({
  languages: extractProgrammingLanguages(experience),
  techStacks: extractTechStacks(experience),
  operatingSystems: extractOperatingSystems(experience),
});

export const findCompaniesByTechnology = (experience, technology) => {
  const companies = [];
  const programmingLanguages = ['C', 'C++', 'C#', 'JavaScript', 'Java', 'Kotlin', 'Python', 'PHP', 'PowerShell', 'Bash', 'MEL', 'TypeScript', 'Go', 'Rust', 'Swift', 'Objective-C', 'Ruby', 'Perl', 'Scala', 'Haskell', 'Clojure', 'F#'];
  const techLowerSearch = String(technology).toLowerCase();

  (experience || []).forEach(exp => {
    const hasTechnology = (() => {
      if (programmingLanguages.some(lang => lang.toLowerCase() === techLowerSearch)) {
        return (exp.technologies || []).some(tech => tech === technology);
      } else {
        return (exp.technologies || []).some(tech => {
          const t = String(tech).toLowerCase();
          if (t === techLowerSearch) return true;
          if (t.includes(techLowerSearch)) {
            const regex = new RegExp(`\\b${techLowerSearch}\\b`, 'i');
            return regex.test(String(tech));
          }
          return false;
        });
      }
    })();

    if (hasTechnology) {
      companies.push({
        id: exp.id,
        company: exp.company,
        position: exp.title, // map to title
        period: exp.period,
        technologies: exp.technologies || [],
        logo: exp.logo,
      });
    }
  });
  return companies;
};

